export const CHART_COLORS = [
  '#2563EB', // blue-600
  '#0D9488', // teal-600
  '#4F46E5', // indigo-600
  '#7C3AED', // violet-600
  '#DB2777', // pink-600
  '#EA580C', // orange-600
  '#059669', // emerald-600
  '#0284C7', // sky-600
]

// Negative bars (e.g. shortfall months in monthly net cash flow) render in
// red so the chart reads at a glance. Applied when a bar's value is < 0
// and the spec didn't already provide its own per-point color.
export const NEGATIVE_BAR_COLOR = '#DC2626' // red-600

export const CHART_COLOR_NAMES = {
  blue: '#2563EB',
  teal: '#0D9488',
  indigo: '#4F46E5',
  violet: '#7C3AED',
  pink: '#DB2777',
  orange: '#EA580C',
  emerald: '#059669',
  sky: '#0284C7',
}
